import { render, staticRenderFns } from "./TrashCan.vue?vue&type=template&id=e722740c&"
import script from "./TrashCan.vue?vue&type=script&lang=ts&"
export * from "./TrashCan.vue?vue&type=script&lang=ts&"
import style0 from "./TrashCan.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports